import { ButtonVariant } from './Button';

/**
 * Maps legacy V1 button variants to V2 variants.
 * Use this when consuming dynamic variant strings from external sources
 * (e.g., API responses, config objects) that may contain legacy values.
 *
 * Mapping:
 * - 'primary-red' -> 'negative'
 * - 'subtle', 'transparent' -> 'tertiary'
 * - V2 variants pass through unchanged
 */
export function mapLegacyVariant(
  variant: string | undefined
): ButtonVariant | undefined {
  switch (variant) {
    case 'primary-red':
      return 'negative';
    case 'subtle':
    case 'transparent':
      return 'tertiary';
    case 'primary':
    case 'secondary':
    case 'tertiary':
    case 'negative':
    case 'positive':
      return variant;
    default:
      return undefined;
  }
}
